<template>
	<div class="agency-properties-container">
		<admin-header />
		
		<div class="container">
	    	<div class="row">
	    		<div class="mx-auto col-lg-8 col-12">
		            <slot></slot>
		        </div>
		   	</div>
		</div>

	    <div class="footer">
	      	<div class="row justify-content-between align-items-center">
		        <div class="col">
		          	<p class="text-center font-size-sm mb-0">© 2020 Cashouse Srl | P.IVA 03896251208</p>
		        </div>
	      	</div>
	    </div>
	</div>
</template>

<script>
	import AdminHeader from '@/Layouts/Partials/AdminHeader'

	export default {
		components: {
			AdminHeader
		}
	}
</script>